import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from '../actions';
import FormResponseAdd from '../components/LeadEngageV2/CreateCampaign';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

function mapStateToProps(state) {
  return {
    formresponse: state.Formresponse,
    business: state.business,
    auth: state.auth,
    carriers: state.carriers,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FormResponseAdd);
